/*
----------------------------
Module - header-desktop-search
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';
    
    fmg.headerDesktopSearch = function () {

        function closeHeaderDesktopSearch() {
            $header_desktop_search.removeClass(header_desktop_search_active_class);
        }

        function setupDesktopSearchToggle() {

            $header_desktop_search_toggle.on("click", function(event) {

                // Don't direct the user after clicking this anchor link
                event.preventDefault();
                
                // Don't bubble up to body to trigger setupCloseDesktopSearchOnOutsideClick()
                event.stopPropagation();

                if (!isDesktopSearchOpened()) {

                    $header_desktop_search.addClass(header_desktop_search_active_class);

                    // Safari for some reason won't let you immediately focus on the field after its made visible
                    // Need the setTimeout
                    setTimeout(function(){ $header_desktop_search_input.trigger("focus"); }, 10);

                }
                
            });

        }

        function setupDesktopSearchCloseBtn() {

            $header_desktop_search_close_btn.on("click", function(event) {

                // Don't bubble up to body to trigger setupCloseDesktopSearchOnOutsideClick()
                event.stopPropagation();

                closeHeaderDesktopSearch();

            });

        }

        function setupCloseDesktopSearchOnOutsideClick() {

            $(document).on("click", function(event){

                var $target = $(event.target);
                var parent = header_desktop_search_class;

                // Only run if the clicked element was not within the component and the search is opened
                if(!fmg.fn.isElementWithinParent($target, parent) && isDesktopSearchOpened()) {
                    closeHeaderDesktopSearch();
                }

            });

        }

        function isDesktopSearchOpened() {
            return $header_desktop_search.hasClass(header_desktop_search_active_class);
        }

        function init() {

            $header = $(".header");

            if ($header.length) {

                $header_desktop_search_toggle = $header.find(".side-icon-link-search");
                $header_desktop_search = $header.find(header_desktop_search_class);
                
                if ($header_desktop_search_toggle.length && $header_desktop_search.length) {

                    setupDesktopSearchToggle();

                    $header_desktop_search_input = $header_desktop_search.find(".header__desktop-search-input");

                    $header_desktop_search_close_btn = $header_desktop_search.find(".header__desktop-search-close-btn");

                    if ($header_desktop_search_close_btn.length) {
                        setupDesktopSearchCloseBtn();
                    }
                    
                    setupCloseDesktopSearchOnOutsideClick();

                }

            }
            
        }

        var $header;
        
        var $header_desktop_search;
        var header_desktop_search_class = ".header__desktop-search";

        var $header_desktop_search_toggle;
        var $header_desktop_search_input;
        var $header_desktop_search_close_btn;

        var header_desktop_search_active_class = "header__desktop-search--active";
        
        return {
            init: init
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.headerDesktopSearch.init();
    });

}());
